import { useParams } from 'react-router';

export function useIdFromRoute(): string | undefined {
    const { id } = useParams<{ id: string }>();

    return id && Number(id) > 0 ? id : undefined;
}
